<script setup>
const props = defineProps({
  name: {
    type: String,
    required: true,
  },
  showError: {
    type: Boolean,
    default: false,
  },
	version: {
		type: String,
		default: 'default'
	}
})
</script>

<template>
  <div class="relative" :class="version">
    <input
      class="checkbox"
      :id="name"
      type="checkbox"
      @change="$emit('toggle', $event)"
    />
    <label :for="name" class="text-sm leading-6">
      <slot />
    </label>
    <ul v-if="showError" class="formkit-messages top-[100%]">
      <li class="formkit-message">Please agree with our terms and conditions.</li>
    </ul>
  </div>
</template>

<style lang="scss" scoped>
.checkbox {
  position: absolute;
  opacity: 0;

  & + label {
    position: relative;
    display: block;
    cursor: pointer;
    padding: 0;
    padding-left: 32px;
		font-size: 12px;
		font-weight: 400;
		line-height: 130%;
		letter-spacing: 0.18px;
		color: theme('colors.light');

    html.light & {
      color: theme('colors.dark');
    }

    &::before {
      position: absolute;
      left: 0;
      top: -2px;
      content: '';
      margin-right: 10px;
      display: inline-block;
      vertical-align: text-top;
      width: 20px;
      height: 20px;
      background: transparent;
      border: 1px solid theme('colors.light');

      html.light & {
        border: 1px solid theme('colors.dark');
      }
    }

		&:deep(a) {
			text-decoration: underline;

			&:hover {
				text-decoration: none;
			}
		}
  }

  &:focus + label {
    &::before {
      box-shadow: 0 0 0 3px rgba(0, 0, 0, 0.12);

      html.light & {
        box-shadow: 0 0 0 3px rgba(255, 255, 255, 0.12);
      }
    }
  }

  &:checked + label {
    &::after {
      content: '';
      position: absolute;
      left: 7px;
      top: -1px;
      width: 7px;
      height: 13px;
      transform: rotate(45deg);
      border-right: 2px solid theme('colors.light');
      border-bottom: 2px solid theme('colors.light');

      html.light & {
        border-right: 2px solid theme('colors.dark');
        border-bottom: 2px solid theme('colors.dark');
      }
    }
  }
}
</style>
